(function () {
  var AUTO_SCROLL_MS = 4500;

  function initSection(root) {
    if (!root || root.dataset.sbvInit === 'true') return;
    root.dataset.sbvInit = 'true';

    var track = root.querySelector('[data-shop-by-video-track]');
    if (!track) return;

    var cards = Array.from(root.querySelectorAll('.shop-by-video__card'));
    var prevBtn = root.querySelector('[data-sbv-prev]');
    var nextBtn = root.querySelector('[data-sbv-next]');
    var autoTimer = null;
    var userPausedScroll = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Play/pause per card + autoplay on load */
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var playBtn = card.querySelector('[data-sbv-play]');

      if (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.removeAttribute('controls');
        video.loop = true;

        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
          video.removeAttribute('data-src');
        }

        /* Autoplay on page load / refresh */
        var tryPlay = function () {
          var p = video.play();
          if (p && typeof p.then === 'function') {
            p.then(function () {
              if (playBtn) {
                playBtn.classList.add('is-playing');
                playBtn.setAttribute('aria-label', 'Pause video');
              }
            }).catch(function () {});
          }
        };
        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener('loadeddata', tryPlay, { once: true });
          tryPlay();
        }

        if (playBtn) {
          playBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) {
              video.play().catch(function () {});
              /* Resume carousel auto-scroll when user plays again */
              userPausedScroll = false;
              startAutoScroll();
            } else {
              video.pause();
              /* Pause carousel while video is paused */
              userPausedScroll = true;
              stopAutoScroll();
            }
          });
        }

        video.addEventListener('play', function () {
          if (playBtn) {
            playBtn.classList.add('is-playing');
            playBtn.setAttribute('aria-label', 'Pause video');
          }
        });

        video.addEventListener('pause', function () {
          if (playBtn) {
            playBtn.classList.remove('is-playing');
            playBtn.setAttribute('aria-label', 'Play video');
          }
        });
      }
    });

    function getCardStep() {
      var card = cards[0];
      if (!card) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.offsetWidth + gap;
    }

    function scrollToIndex(index) {
      if (!cards.length) return;
      var step = getCardStep();
      track.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    function getActiveIndex() {
      var step = getCardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByCard(direction) {
      if (!cards.length) return;
      var index = getActiveIndex();
      var next = index + direction;
      if (next < 0) next = cards.length - 1;
      if (next >= cards.length) next = 0;
      scrollToIndex(next);
    }

    function stopAutoScroll() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function startAutoScroll() {
      stopAutoScroll();
      if (reduceMotion || userPausedScroll || cards.length < 2) return;
      autoTimer = setInterval(function () {
        scrollByCard(1);
      }, AUTO_SCROLL_MS);
    }

    function restartAutoScroll() {
      if (userPausedScroll) return;
      startAutoScroll();
    }

    updateNav();

    /* Auto-scroll only while section is on screen — never hijack page scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              restartAutoScroll();
            } else {
              stopAutoScroll();
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    } else {
      startAutoScroll();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
        restartAutoScroll();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
        restartAutoScroll();
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNav);
    });

    /* Pause auto-scroll while user interacts with track */
    track.addEventListener('pointerdown', function () {
      stopAutoScroll();
    });
    track.addEventListener('pointerup', function () {
      restartAutoScroll();
    });
    track.addEventListener('mouseenter', function () {
      stopAutoScroll();
    });
    track.addEventListener('mouseleave', function () {
      restartAutoScroll();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoScroll();
        cards.forEach(function (card) {
          var video = card.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      } else {
        cards.forEach(function (card) {
          var video = card.querySelector('video');
          if (video) {
            video.play().catch(function () {});
          }
        });
        userPausedScroll = false;
        startAutoScroll();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-by-video]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      var el = event.target.querySelector('[data-shop-by-video]') || event.target;
      if (el && el.dataset) el.dataset.sbvInit = '';
      initSection(el);
    }
  });
})();
